import {
  ICompliancePolicies,
  IIndustryCompliancePolicies,
} from '../../models/SecurityGovernanceModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';

const serviceType = ServiceType.None;

export class SecurityGovernanceService {
  private readonly service: ApiServiceBase = new ApiService(serviceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(
    ServiceType.None,
    ServerType.dcaBackend,
  );

  public getComplianceDetails(
    landingZoneID: string,
  ): Promise<ICompliancePolicies> | ICompliancePolicies {
    const route: string[] = [API_ROUTE.LANDING_ZONE.BASE, API_ROUTE.COMPLIANCE, landingZoneID];
    return this.dcaBackendService.get({ route: route });
  }

  public getIndustryComplianceDetails(
    landingZoneID: string,
  ): Promise<IIndustryCompliancePolicies> | IIndustryCompliancePolicies {
    const route: string[] = [API_ROUTE.LANDING_ZONE.INDUSTRY, API_ROUTE.COMPLIANCE];
    return this.service.get({ route: route, query: { landingzone_id: landingZoneID } });
  }

  public getComplianceSummary(
    projectId: string,
  ): Promise<ICompliancePolicies> | ICompliancePolicies {
    const route: string[] = [API_ROUTE.LANDING_ZONE.BASE, API_ROUTE.COMPLIANCE_CUMULATIVE];
    return this.dcaBackendService.get({ route: route, query: { cumulative: true, projectId } });
  }
}

const securityGovernanceService = new SecurityGovernanceService();
export default securityGovernanceService;
